import React from 'react';
import { Combo } from 'fw/forms';

class NotificationDaysCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    completed = () => { return this._ctrl.completed(); }
    flag = () => { return this._ctrl.flag(); }

    componentDidMount = () => {
        this._isMounted = true;

        this.loadNotificationDays(null);
    }

    loadNotificationDays = () => {
        let items = [];

        items.push({ label: "10 Days", value: 10});
        items.push({ label: "30 Days", value: 30});
        items.push({ label: "60 Days", value: 60});
        items.push({ label: "90 Days", value: 90});
        items.push({ label: "120 Days", value: 120});
        items.push({ label: "150 Days", value: 150});
        items.push({ label: "180 Days", value: 180});

        this.setState({items});
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <Combo
                {...this.props}
                placeholder={this.props.placeholder ? this.props.placeholder : "Trigger Days"}
                items={this.state.items}
                searchable={true}
                ref={(c) => { this._ctrl = c }} />
        )
    }
}

export default NotificationDaysCombo;

// Mark this as a form component
NotificationDaysCombo.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/notificationDaysCombo/NotificationDaysCombo.js